import { c as _c } from "react/compiler-runtime";
import { MAIN_API } from 'modules/main/api/main-api';
import { MainEventsApiInterface } from 'modules/main/types/main-interface';
import { useCallback } from 'react';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useInfiniteControlledSwr } from 'shared/hooks/use-infinite-controlled-swr';
import useUser from 'shared/hooks/use-user';
import { LimitType, OrderEnum } from 'shared/types/pagination-interface';
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string';
const EVENTS_LIMIT: LimitType = 25;
export function useMainEvents() {
  const $ = _c(18);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = (_pageIndex, previousPage) => {
      const lastEvent = previousPage?.items.at(-1);
      if (previousPage && (!previousPage.hasMore || !lastEvent)) {
        return null;
      }
      return [`${MAIN_API}/events?${getPaginationQueryString({
        limit: EVENTS_LIMIT,
        pagination: {
          order: OrderEnum.next,
          startFromId: lastEvent?.id
        }
      })}`, user, RequestModuleEnum.Contacts];
    };
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    error,
    isValidating,
    size,
    setSize
  } = useInfiniteControlledSwr(t1, fetcher, undefined, !!user);
  let t2;
  if ($[3] !== data) {
    t2 = data?.at(-1);
    $[3] = data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const lastPage = t2;
  let t3;
  if ($[5] !== setSize) {
    t3 = () => setSize(_temp);
    $[5] = setSize;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const loadMore = t3;
  let t4;
  if ($[7] !== setSize) {
    t4 = () => setSize(_temp2);
    $[7] = setSize;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const retry = t4;
  let t5;
  if ($[9] !== data) {
    t5 = data?.flatMap(_temp3);
    $[9] = data;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = !!lastPage?.hasMore && !!lastPage.items.length;
  const t7 = !!data && data.length < size && (!error || isValidating);
  let t8;
  if ($[11] !== error || $[12] !== loadMore || $[13] !== retry || $[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = {
      events: t5,
      error,
      hasMore: t6,
      isLoadingMore: t7,
      loadMore,
      retry
    };
    $[11] = error;
    $[12] = loadMore;
    $[13] = retry;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
function _temp3(page) {
  return page.items;
}
function _temp2(currentSize_0) {
  return currentSize_0;
}
function _temp(currentSize) {
  return currentSize + 1;
}